import { useEffect } from 'react'
import { Navigate } from 'react-router-dom'

import { useAttendanceDateNavigator } from '../lib/attendanceDateNavigatorContext'
import useCustomPeriodPath from '../lib/useCustomPeriodPath'

const NavigateToCustomPeriodIndexPage = () => {
  const { resetAttendanceDateNavigator } = useAttendanceDateNavigator()
  const path = useCustomPeriodPath()

  useEffect(() => {
    resetAttendanceDateNavigator()
  }, [])

  return <Navigate replace to={path} />
}

export default NavigateToCustomPeriodIndexPage
